/**
 * @ngdoc directive
 * @name formDate
 *
 * @description
 * Form date validator handler
 */
module.directive('formDate', ['lodash', 'moment', function (lodash, moment) {
    'use strict';
    return {
        require:'^ngModel',
        restrict:'A',
        link: function ($scope, element, attrs, ctrl) {
            // format model value for html5 input[date] field
            ctrl.$formatters.unshift(function (value) {
                if (value && moment(value, ['YYYY-MM-DD']).isValid()) {
                    return moment(value, ['YYYY-MM-DD']).format('DD/MM/YYYY')
                } 
                return value;
            });
        }
    };
}]);